<template>
    <RowColumn>
        <Pagination :search="search" :base-url="baseUrl" :total-items="totalItems" :method-name="methodName" />
    </RowColumn>
</template>

<script>
    import RowColumn from "./RowColumn";
    import Pagination from "./html/Pagination";

    export default {
        name: "PaginationRow",
        components: {Pagination, RowColumn},
        props: {
            baseUrl: {
                type: String,
                required: true,
            },
            totalItems: {
                type: Number,
                required: true,
            },
            methodName: {
                type: String,
                required: true,
            },
            search: {
              type: Object,
              required: true
            }
        }
    }
</script>

<style scoped>

</style>